import { Avatar, Box, Collapse, Divider, Drawer, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { styled } from '@mui/material/styles';
import { sideBarEnum } from '../../enums/SideBar.enums';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AnimatedLogo from '../global/AnimatedLogo';
import { useAuth } from '../../hooks/useAuth';
import { routes } from '../../pages/routes';
import { Icon } from '@iconify/react';
import { ExpandLess, ExpandMore, StarBorder } from '@mui/icons-material';
import { useMenuItem } from '../../hooks/useMenuItem';
import { useDispatch } from 'react-redux';
import { toggleSideBar } from '../../store/reducers/display.reducer';
import palette from '../../theme/palette';
import { useUserActivityLog } from '../../hooks/useUserActivityLog';

type sideBarProps = {
  open: boolean,
  onClose?: () => void,
  isMenuHidden?: boolean,
}
const drawerWidth = 290;
const closedDrawerWidth = 70;

function SideBar({ open, onClose, isMenuHidden = false }: sideBarProps) {
  const [openProfile, setOpenProfile] = useState(false)
  const location = useLocation();
  const { t } = useTranslation()
  const { menu } = useMenuItem(20)
  const dispatch = useDispatch()
  const { track } = useUserActivityLog()

  return (
    <Drawer
      PaperProps={{
        // className: 'glass',
        sx: {
          background: 'hsla(0, 0%, 10%,.4) !important',
        }
      }}
      sx={{
        width: open ? drawerWidth : isMenuHidden ? 0 : closedDrawerWidth,
        position: 'relative',
        height: '100vh',
        overflow: 'hidden',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? drawerWidth : isMenuHidden ? 0 : closedDrawerWidth,
          boxSizing: 'border-box',
          scrollbarWidth: 'none', // ✅ Hides scrollbar in Firefox
          msOverflowStyle: 'none', // ✅ Hides scrollbar in IE/Edge
          '&::-webkit-scrollbar': {
            display: 'none', // ✅ Hides scrollbar in Chrome/Safari
          },
        },
      }}
      variant="persistent"
      anchor="left"
      open={true}
    >

      <Box p={1}>
        <AnimatedLogo
          isMenuHidden={isMenuHidden}
          onclose={() => { open && setOpenProfile(false) }}
          open={open}></AnimatedLogo>
      </Box>
      <Divider />
      <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={'100%'}>
        <List sx={{
          flexGrow: 2,
        }}

        >
          <>
            {sideBarEnum(location.pathname).map(item => (
              <ListItem key={item.key} >
                <Tooltip arrow placement='right' title={!open ? t(item.key) : ''}>
                  <ListItemButton
                    disableRipple
                    disableTouchRipple
                    component={Link}
                    onClick={() => track(item.event_name)}
                    rel="noopener noreferrer"
                    to={item.path}
                    sx={{
                      borderRadius: 1,
                      "&:hover": {
                        fontWeight: 500,
                      },
                      "&.Mui-selected": {
                        backgroundColor: palette.light.primary.main,
                      },
                      px: !open ? 1 : 'inherit',
                    }}
                    selected={item.selected}
                  >
                    <ListItemIcon sx={{ mx: !open ? 0 : 1 }}>
                      {item.icon}
                    </ListItemIcon>
                    {
                      open && <ListItemText primary={<Typography fontSize={'14px'}>{t(item.key)}</Typography>} />
                    }

                  </ListItemButton>
                </Tooltip>
              </ListItem>
            ))}
            <ListItem >
              <Tooltip arrow placement='right' title={!open ? t('navbar:myAccount') : ''}>
                <ListItemButton sx={{
                  borderRadius: 1, display: "flex",
                  px: !open ? 1 : 'inherit',
                }} onClick={() => {
                  if (!open) {
                    dispatch(toggleSideBar(true));
                  }

                  let value = !openProfile
                  setOpenProfile(value)
                  if (value) {
                    track('MY_ACCOUNT_MENU_ITEM_CLICKED')
                  }
                }}>
                  <ListItemIcon
                    sx={{ mx: !open ? 0 : 1 }}
                  >
                    <Icon width={24} height={24} icon='flowbite:user-settings-solid' />
                  </ListItemIcon>
                  {
                    open && <>
                      <ListItemText primary={<Typography fontSize={'14px'}>{t('navbar:myAccount')}</Typography>} />
                      {openProfile ? <ExpandLess /> : <ExpandMore />}
                    </>
                  }

                </ListItemButton>
              </Tooltip>
            </ListItem>
            <Collapse sx={{ mt: 0, pt: 0 }} in={openProfile} timeout="auto" unmountOnExit>

              <List component="div" sx={{ pl: !open ? 0 : 2 }} >
                {
                  menu.map(m => (
                    <ListItem key={m.key} >
                      <Tooltip arrow placement='right' title={!open ? t(m.key) : ''}>
                        <ListItemButton
                          sx={{
                            borderRadius: 1,
                            "&:hover": {
                              fontWeight: 500,
                            },
                            "&.Mui-selected": {
                              backgroundColor: palette.light.primary.main,
                            },
                            px: !open ? 1 : 'inherit',

                          }}
                          disableRipple disableTouchRipple target={m.target} component={m?.link ? Link : 'li'} to={m?.link ?? ''} key={m.key} onClick={() => m.fn?.()}>
                          <ListItemIcon
                            sx={{ mx: !open ? 0 : 1 }}
                          >
                            {m.icon}
                          </ListItemIcon>
                          {
                            open && <Typography variant='body2'>{t(m.key)}</Typography>
                          }

                        </ListItemButton>
                      </Tooltip>
                    </ListItem>
                  ))
                }
              </List>
            </Collapse>
          </>
        </List>

      </Box>

    </Drawer >
  )
}

export default SideBar